module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-google-map-search-box"
  }, [_c('input', {
    staticClass: "input controls",
    attrs: {
      "id": this._uid + '-search-input',
      "type": "text",
      "placeholder": "Search..."
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-695d2981!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/map/GoogleMapSearchBox.vue
// module id = 2550
// module chunks = 1